import { USER_ROLES } from '../../auth/index';

const PERMISSIONS = [
	USER_ROLES.CSM,
	USER_ROLES.IMPLEMENTATION,
	USER_ROLES.LANGOS_APP,
	USER_ROLES.OPS,
	USER_ROLES.OWNER,
];

export default {
	BILLING: {
		ACTIVE: true,
		NAME: 'manage-billing',
		LABEL: 'Billing',
		ICON: 'money-dollar-circle',
		PATH: '/billing',
		PERMISSIONS,
	},
};
